import React, { useCallback, useMemo, useState } from "react";
import { Button, Grid } from "@mui/material";
import moment from "moment";
import { Link } from "react-router-dom";
import { IconCheck, IconX } from "@tabler/icons"; // or wherever yours come from

import TableComponent from "components/TopCourtComponents/Table/TableComponent"; // your existing
import { TCLabel } from "components/TopCourtComponents/Label/TopCourtLabel"; // assuming

// TODO: replace helpers with your existing ones
import { currencyFormat } from "helper/NumberFormat";

// NOTE: you already have raining icon usage
import raining from "assets/images/raining.png";
import MerchantDepositDialog from "./dialog/merchantDepositDialog";
import { getUrlCourtCode } from "helper/Court";
import { getFirstLetters } from "helper/String";

export default function MerchantDeposit({
    rows = [],
    totalData = 0,
    loading = false,
    filter,
    onChangePage,
    merchantId, // optional for disabling link like your logic
    refetch, // call to reload list after approve/reject
    fromBalance = false
}) {
    const [openDialog, setOpenDialog] = useState({
        open: false,
        type: null, // "accept" | "reject"
        data: null,
    });

    const closeDialog = () =>
        setOpenDialog((prev) => ({
            ...prev,
            open: false,
            type: null,
            data: null,
        }));

    const valueCustomator = useCallback(
        (row) => {
            let admin = row.createdBy.placeId ? row.createdBy.placeId.name : row.createdBy.merchantId ? row.createdBy.merchantId.name : '';
            return {
                createdDate: <TCLabel>{moment(row.createdDate).format("YYYY/MM/DD HH:mm:ss")}</TCLabel>,
                refId: merchantId ? (
                    <TCLabel>{row.refId}</TCLabel>
                ) : (
                    <Link className="span-link" to={`/${getUrlCourtCode()}/orders/${row._id}`}>
                        {row.refId}
                    </Link>
                ),
                user: <TCLabel>{row.createdBy ? `${row.createdBy.name} ${getFirstLetters(admin).toUpperCase() || 'STC'}` : row.merchantId ? row.merchantId.name : "-"}</TCLabel>,
                total: <TCLabel>{currencyFormat(row.deposit)}</TCLabel>,
                action: (
                    <div>
                        {!row.isClosed && !fromBalance ? (
                            <Grid container spacing={1}>
                                <Grid item>
                                    <Button
                                        variant="contained"
                                        style={{ backgroundColor: "#E35480" }}
                                        onClick={() =>
                                            setOpenDialog((prev) => ({
                                                ...prev,
                                                type: "reject",
                                                open: true,
                                                data: row,
                                            }))
                                        }
                                    >
                                        <IconX size={15} />
                                    </Button>
                                </Grid>

                                <Grid item>
                                    <Button
                                        variant="contained"
                                        sx={{ backgroundColor: "#0198E1" }}
                                        onClick={() =>
                                            setOpenDialog((prev) => ({
                                                ...prev,
                                                type: "accept",
                                                open: true,
                                                data: row,
                                            }))
                                        }
                                    >
                                        <IconCheck size={15} />
                                    </Button>
                                </Grid>
                            </Grid>
                        ) : row.status === "rejected" ? (
                            fromBalance ? "Failed" : "Payment Failed"
                        ) : row.status === "approved" ? (
                            fromBalance ? "Success" : "Paid"
                        ) : (
                            fromBalance ? "Pending" : row.status
                        )}
                    </div>
                )
            };
        },
        [merchantId]
    );

    const columns = useMemo(
        () => [
            { label: "Created Date" },
            { label: "Ref Id" },
            { label: "User" },
            { label: "Total" },
            { label: fromBalance ? "Status" : "Action" },
        ],
        []
    );

    return (
        <>
            <TableComponent
                columns={columns}
                loading={loading}
                valueCustomator={valueCustomator}
                totalData={totalData}
                rows={rows}
                page={filter?.page || 0}
                pageChange={(e) => onChangePage({ page: e })}
            // rowWidth={{
            //     createdDate: "160px",
            //     bookingId: "160px",
            //     user: "231px",
            //     total: "160px",
            //     action: "180px",
            // }}
            />

            <MerchantDepositDialog
                openDialog={openDialog}
                onClose={closeDialog}
                onDone={() => refetch?.()}
            />
        </>
    );
}
